import { Box } from "@mui/material";
import { DropdownBase } from "../../theme/dropdowns/Dropdown";
import Text from "../../theme/text/Text";
import cx from 'classnames';
import { condition_object_type } from "../../../utils/staticEnums";

export const CRValueSingleSelect = ({
  ruleline,
  index,
  selectRuleLineValue,
  errorMap,
  colors,
  t,
  getListOptions,
  props,
  lazyMount,
}) => {
  const options = getListOptions(ruleline?.valueType, props, t, true, ruleline?.listValues) || [];
  const isFieldType = ruleline.objectType === condition_object_type.ORDERFIELD || ruleline.objectType === condition_object_type.PRODUCTFIELD;

  // For orderfield/productfield, convert stored value to index for selection
  const getSelectedIndex = () => {
    if (isFieldType && ruleline.listValues && Array.isArray(ruleline.listValues) && ruleline.value != null) {
      const idx = ruleline.listValues.indexOf(ruleline.value);
      return idx !== -1 ? idx : ruleline.value;
    }
    return ruleline.value;
  };

  const selectedIndex = getSelectedIndex();
  const selectedOption = options.find(value => value.id === selectedIndex);
  const hasError = errorMap && errorMap[index] && errorMap[index].value;

  // Handle value transformation internally for orderfield/productfield
  const handleChange = (selected) => {
    if (isFieldType && ruleline.listValues && Array.isArray(ruleline.listValues)) {
      // selected is an index, convert to value
      const value = ruleline.listValues[selected];
      selectRuleLineValue(value !== undefined ? value : selected, index);
    } else {
      selectRuleLineValue(selected, index);
    }
  };

  return (
    <DropdownBase
      lazyMount={lazyMount}
      displayName="name"
      valueKey="id"
      multiple={false}
      onChange={handleChange}
      noSelection=""
      options={options}
      selected={selectedOption?.id}
      searchOptions={{ enabled: true, placeholder: t("search") }}
      styles={{ minWidth: 300 }}
      disallowDeselection
    >
      <Box
        className={cx('', { error: hasError })}
        sx={{
          ml: "auto",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          background: colors.grey[100],
          height: 32,
          minWidth: 120,
          borderRadius: 4,
          "&:hover": {
            background: colors.grey[200],
            cursor: "pointer",
          },
          "&.error": {
            background: colors.red[100],
          },
        }}
      >
        <Text noBreak>{selectedOption?.name}</Text>
      </Box>
    </DropdownBase>
  );
};
